import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  iconButtonStyle: {
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: '10px',
    lineHeight: '14px',
    cursor: 'pointer',
    borderRadius: '4px',
  },
}));

const CustomIconButton = ({ onClick, icon, size, color, disabled, label }) => {
  const classes = useStyles();
  return (
    <IconButton className={classes.iconButtonStyle} onClick={onClick} size={size} disabled={disabled} color={color}>
      {icon} {label}
    </IconButton>
  );
};

CustomIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.element.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  color: PropTypes.string,
};

CustomIconButton.defaultProps = {
  color: 'primary',
  size: 'small',
  disabled: false,
};

export default React.memo(CustomIconButton);
